import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  ErrorStateMatcher
} from '@angular/material';
import { ApiNotificiacionesService } from '../../../shared/services/api-notificaciones.service';
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators
} from '@angular/forms';
import { AppStorage } from 'src/app/shared/services/appStorage.service';

@Component({
  selector: 'app-modal-template',
  templateUrl: './modal-template.component.html',
  styleUrls: ['./modal-template.component.css']
})
export class ModalTemplateComponent {
  loadingEditor = true;
  loadingGuardar = false;
  loadingEnviarCorreo = false;
  cuerpoNotificacion;
  titulo;
  logo;
  departamento;
  step = 'editor';
  correoEnviado = false;

  emailPrueba = '';
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  matcher = new MyErrorStateMatcher();

  @ViewChild('previsualizacionContainer')
  previsualizacionContainer: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<ModalTemplateComponent>,
    private appStorage: AppStorage,
    private apiNotificacionesService: ApiNotificiacionesService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.cuerpoNotificacion = data.notificacion.cuerpo;
    this.titulo = data.notificacion.nombre;
    this.logo = data.logo;
    this.departamento = data.departamento;
  }

  cancel(): void {
    this.dialogRef.close();
  }

  mostrarPrevisualizacion() {
    this.step = 'previsualizacion';
    setTimeout(() => {
      this.previsualizacionContainer.nativeElement.src =
        'data:text/html;charset=ISO-8859-1,' +
        escape(this.crearCuerpoTemplate(this.reemplazarCamposDinamicos(this.cuerpoNotificacion)));

      setTimeout(() => {
        this.previsualizacionContainer.nativeElement.contentDocument.body.style.fontFamily =
          'Roboto, "Helvetica Neue", sans-serif';
      }, 200);
    }, 100);
  }

  reemplazarCamposDinamicos(cuerpo: String) {
    return cuerpo
      .replace(/{empresa}/g, 'Amparo del Sol')
      .replace(/{proceso}/g, 'Ajustes y Recargos')
      .replace(/{anio}/g, '2018')
      .replace(/{mes}/g, 'Diciembre')
      .replace(/{correo}/g, 'felipe@amparodelsol.cl')
      .replace(/{departamento}/g, 'Departamento de Transferencias Económicas')
      .replace(/{versionamiento}/g, 'VE01')
      .replace(/{fechamax}/g, '31-12-2018')
      .replace(/{usuario}/g, this.appStorage.datosSesion.usuario);
  }

  crearCuerpoTemplate(cuerpoNotificacion) {
    let correo = cuerpoNotificacion;
    if (this.logo) {
      correo =
        correo +
        '<table cellspacing="15">   <tr>     <th>     	<img src="' +
        this.logo +
        `">	     </th>     <th style="text-align: left; font-family: sans-serif;">     <strong style="font-size: 14px; color: #222;">${
          this.departamento.nombre
        }</strong>     <p style="color: #666; font-size: 12px; padding: 0; margin: 0; font-weight: normal;">${
          this.departamento.firma.gerencia
        }<br>${this.departamento.firma.direccion}<br>${
          this.departamento.firma.comuna
        }<br> 	Tel: ${this.departamento.firma.telefono}<br>${
          this.departamento.firma.web
        }</p>	     </th>   </tr> </table>`;
    } else {
      correo =
        correo +
        `<table cellspacing="15">   <tr>     <th></th>     <th style="text-align: left; font-family: sans-serif;">     <strong style="font-size: 14px; color: #222;">${
          this.departamento.nombre
        }</strong>     <p style="color: #666; font-size: 12px; padding: 0; margin: 0; font-weight: normal;">${
          this.departamento.firma.gerencia
        }<br>${this.departamento.firma.direccion}<br>${
          this.departamento.firma.comuna
        }<br> 	Tel: ${this.departamento.firma.telefono}<br>${
          this.departamento.firma.web
        }</p>	     </th>   </tr> </table>`;
    }

    return correo;
  }

  enviarCorreoPrueba() {
    this.apiNotificacionesService
      .enviarCorreoPrueba(this.reemplazarCamposDinamicos(this.cuerpoNotificacion), this.emailFormControl.value)
      .then(() => {
        this.loadingEnviarCorreo = false;
        this.correoEnviado = true;
      })
      .catch(error => {
        this.loadingEnviarCorreo = false;
        this.correoEnviado = false;
      });
  }

  volver() {
    this.step = 'editor';
  }

  guardarNotificacion() {
    this.loadingGuardar = true;

    this.apiNotificacionesService
      .guardarNotificacion(
        this.cuerpoNotificacion,
        this.data.notificacion.idTipoEmail
      )
      .then(res => {
        this.loadingGuardar = false;
        this.step = 'ok';
        this.dialogRef.updateSize('400px');
        console.log(res);
      })
      .catch(error => {
        console.log(error);
      });
  }

  ok() {
    this.dialogRef.close(true);
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.hasError('email') &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}
